module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc146554286"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("Do what you can, with what you have, where you are.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Theodore Roosevelt")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("What a father says to his children is not heard by the world,")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("but it will be heard by posterity.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Jean Paul")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("Don’t die with your music still in you.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Wayne Dyer")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_20"
  }, [_vm._v("Dammit! That’s three nights in a row!")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I’m tired of waking up every morning with a fucking wet spot in my bed. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("As if I didn’t have enough to worry about.")]), _vm._v(" Startin’ to wonder if my dreams have anything to do with it. I can’t remember ‘em in detail but I do know they’re about girls. Lately, they’ve been pretty intense, more arousing than usual—they even wake me up.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I’m embarrassed to tell Mom. Besides, she’d just drag me off to see some kinda ‘ologist. And I ain’t going through that shit any more than I have to. Getting my balls squeezed by the doctor for a sports physical every summer is bad enough as it is. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Why invite more abuse?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("And definitely not asking Matt or any of the guys. Just one more thing for them to pick on. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("And who needs that shit?")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I grab some clean underwear out of the laundry basket and brush my teeth. Mom has left some sliced fruit in the refrigerator and a note on the front reminding me to eat breakfast. I just never feel like it. Plus, I’m sore as hell from the first coupla hockey practices. No matter how much off-season work I put it, hockey still finds all those muscles I never knew existed.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Out of habit, I knock on Sharon’s door. She has her radio on so loud I know she won’t hear me. I open the door a crack. She’s putting on some kind of make-up while she stares into the mirror over her dresser. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Like that’s gonna help.")]), _vm._v(" I can’t imagine any guy wanting to tangle with that wolverine. Not unless he has a death wish.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Mom told me to remind you that you’re supposed to vacuum and do the dishes after school,” I yell over the deep thump of the music.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Get lost, meat sack.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I’m trying to fathom the apparently intricate work she’s doing to her eyes when she spies me lingering in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Out!”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Such a pleasure to deal with my loving sister. I duck out without further directive lest I’m forced to submit to the wrath of the beast. I locate my shoes near the couch and cram ’em on my feet without bothering to tie the laces. I’m shoving my notebooks into my backpack when Mr. Stewart honks.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("After grabbing my hat and jacket in a dash out the front door, I hustle down the sidewalk to the burly black pickup and climb up into the rear door.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Morning, Derek.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Hi, Mr. Stewart.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Matt’s dad is okay. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("At least, I think so.")]), _vm._v(" Matt complains about him some but not as much as he probably wants to. Since I never see my old man, I guess Matt thinks it wouldn’t be cool to say too much in front of me. Still, they seem to get along pretty well, and even like each other a little. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Kinda jealous to be honest.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("He drops us off on the side street to avoid all the traffic and pedestrians in front of the school.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Thanks again for the ride, Sir,” I add before closing the door.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“No problem. Have a productive day, boys. Make good choices.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Matt and I stroll in silence for a while as we make our way toward the front of the school.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Mutt?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“You like your dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("He shrugs and keeps his focus forward. “Me and the old man don’t always see eye-to-eye on stuff but he’s okay. I mean, I get tired of him riding me and all his stupid rules, but I feel good knowing he’s got my back. Know what I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Not really, no.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Remember that time when we were PeeWees and that team was pissed ’cause I crushed their star forward?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Yeah. You got kicked out, didn’t ya?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Game misconduct and missed the next game, too. Anyway, their coach chased me down after the game and got in my face, started threatening me, saying it was a cheap shot and all.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“No shit. Never knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Yeah, well, Pops stepped in and shut that guy down like nobody’s business. It looked like it might come to blows but at that moment, I think my old man coulda actually backed off the Terminator. He was as tough as I’ve ever seen him.” Matt stops walking to finish, staring off into the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“See, Pops has never really liked the hard hits or the violence of the game like lots of the other dads do. He’s always been more about sportsmanship than anything else. Never stops hounding me to keep my hockey clean, so I knew I was gonna get an earful after that game. But he still stood up to that loudmouth when he threatened me.” Matt smiles and looks at me now.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“I realized, he was standing up for me, his son, even when I knew he didn’t approve of what I’d done…I’ve never forgotten that. Look, I don’t wanna get mushy but tough to miss how much your father cares about you when you look at the big picture.” Matt starts to chuckle. “After we got home, he still chewed my ass but good for that penalty, though, lemme tell ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I can’t help but admire the big goof. I’d like to give him a hug but I settle for a fist bump instead. “Thanks, buddy. You’re the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("He points his finger at me. “Hey, don’t tell nobody what I just said, okay? Anyone gets wind of it, I’ll just get pissed off and start kickin’ some ass. And Pops would not be pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“No worries. We better get to class.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "id": "calibre_pb_23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0352e23a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_012.vue
// module id = 99
// module chunks = 0